// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"d94d4c23","883":"09e7987b"}[chunkId] + ".chunk.js";
};